import { createFileRoute } from "@tanstack/react-router";
import { type } from "arktype";
import { ResetPasswordConfirmation } from "~/components/views/auth/reset-password-confirmation";

export const Route = createFileRoute("/auth/reset-password/confirmation")({
	component: Page,
	validateSearch: type({
		hintEmail: type("string").optional(),
	}),
});

function Page() {
	const { hintEmail } = Route.useSearch();

	return <ResetPasswordConfirmation hintEmail={hintEmail} />;
}
